import { get, isDate } from 'lodash';
/**
 * Get the value of a property from a data object then
 * format the result to a standard format (Date for example)
 * @param value
 * @returns {string}
 */

export function uploadProductPermission() {
  let resultArray = [
    'ExerciceOfOptionOfRV',
    'AnticipationOfTermOperation',
    'TermOperation',
    'StockLoan',
    'SWAPAnticipation',
    'BlockUnblockRF',
    'FlexibleOption',
    'Unit',
    'FixedIncome',
    'AnticipationOfStockLoan',
    'Futur',
    'CashInOrCashOut',
    'ExerciceOfOptionOfFutur',
    'SWAP',
    'BlockUnblockFund',
    'BlockUnblockRV',
    'VariableIncome',
    'Ingresso',
    'Cambio'
  ]
  return resultArray
}
export function getValue(data: any, property: string, defaultValue: any = ''): any {
  const value = get(data, property, defaultValue);
  return !isDate(value) ? value : toIsoString(value);
}
/**
 * Decode the provided value, it is maily used to decode the Query parameters
 * @param value
 * @returns {string}
 */
export function getDecodedValue(value: any): any {
  return value ? decodeURIComponent(value) : value;
}

export function toIsoString(date) {
  var tzo = -date.getTimezoneOffset(),
    dif = tzo >= 0 ? '+' : '-',
    pad = function (num) {
      var norm = Math.floor(Math.abs(num));
      return (norm < 10 ? '0' : '') + norm;
    };

  return date.getFullYear() +
    '-' + pad(date.getMonth() + 1) +
    '-' + pad(date.getDate())
}

export function checkActionByStatus(selectedItems: any, action: String): Boolean {
  var listOfStatus: Array<String> = [];
  selectedItems.forEach(element => {
    listOfStatus.push(element.statusOfOp)
  });
  if (action == "reject") {
    if (
      (listOfStatus.includes("Validated")) ||
      (listOfStatus.includes("Cancelled")) ||
      (listOfStatus.includes("Rejected"))
    ) {
      return false
    } else {
      return true
    }
  } else if (action == "resend") {
    if (
      (listOfStatus.includes("Waiting Validation")) ||
      (listOfStatus.includes("Validated")) ||
      (listOfStatus.includes("Cancelled")) ||
      (listOfStatus.includes("Rejected")) ||
      (listOfStatus.includes("Cut Off Time")) ||
      (listOfStatus.includes("Integration Error")) ||
      (listOfStatus.includes("Pending Authorization"))
     // (listOfStatus.includes("Portal Configuration Error"))||//
     // (listOfStatus.includes("Operation with Error"))|| //
      //) //
    ) {
      return false
    } else {
      return true
    }
  }
  else if (action == "Authorize") {
    if (
      (listOfStatus.includes("Validated")) ||
      (listOfStatus.includes("Cancelled")) ||
      (listOfStatus.includes("Rejected")) ||
      (listOfStatus.includes("Cut Off Time")) ||
      (listOfStatus.includes("Operation with Error")) ||
      (listOfStatus.includes("Portal Configuration Error")) ||
      (listOfStatus.includes("Integration Failure")) ||
      (listOfStatus.includes("Integration Error"))
    ) {
      return false
    } else {
      return true
    }
  }
}

export function checkRowActionByStatus(rowData: any, action: String): Boolean {
  if (action == 'edit') {
    return (
      rowData?.statusOfOp == 'Validated' ||
      rowData?.statusOfOp == 'Cancelled' ||
      rowData?.statusOfOp == 'Rejected'
    )
  } else if (action == 'cancel') {
    return (
      rowData?.statusOfOp == 'Cut Off Time' ||
      rowData?.statusOfOp == 'Pending Authorization' ||
      rowData?.statusOfOp == 'Cancelled' ||
      rowData?.statusOfOp == 'Rejected' ||
      rowData?.statusOfOp == 'Operation with Error' ||
      rowData?.statusOfOp == 'Portal Configuration Error' ||
      rowData?.statusOfOp == 'Integration Error' ||
      rowData?.statusOfOp == 'Integration Failure'
    )
  }
  else if (action == 'duplicate') {
    return (
      rowData?.statusOfOp == 'Operation with Error' ||
      rowData?.statusOfOp == 'Portal Configuration Error' ||
      rowData?.statusOfOp == 'Cancelled' ||
      rowData?.statusOfOp == 'Rejected' ||
      rowData?.statusOfOp == 'Integration Error' 
     // rowData?.statusOfOp == 'Integration Failure'
    )
  }
}

export function checkItemCreator(selectedItems: any,email:String): Boolean {
  var listOfCreator: Array<String> = [];
  selectedItems.forEach(element => {
    listOfCreator.push(element.creatorUserId)
  });
  if (listOfCreator.includes(email)) {
      return false
    } else {
      return true
    }
}

export function getNewMultiSortMeta(eventMultiSortMeta, multiSortMeta) {
  if(multiSortMeta.length&&!multiSortMeta[0]){
    multiSortMeta=[]
  }
  const metaSortArray = multiSortMeta.filter((value, index) => {
    value['indexMultiSortMeta'] = index
    return value.field === eventMultiSortMeta.field
  })

  if (metaSortArray.length)
    multiSortMeta[metaSortArray[0]['indexMultiSortMeta']] = eventMultiSortMeta
  else if (multiSortMeta.length === 3 && eventMultiSortMeta) {
    multiSortMeta.shift()
    multiSortMeta = [eventMultiSortMeta].concat(multiSortMeta)
  } else if (multiSortMeta.length === 2 && eventMultiSortMeta) {
    multiSortMeta = [eventMultiSortMeta].concat(multiSortMeta)
  } else multiSortMeta = [eventMultiSortMeta]
  return multiSortMeta
}
